import React from 'react';

import {LoadingSpinner} from "@proxy/_components";


export default function LoadingSkeleton() {

  return (typeof(window.GCP) != 'undefined' && typeof(window.GCP.pageType) != 'undefined') ? (
    <LoadingSpinner/>
  ) : (
    <div id="gcpPageWrapper">
    <div className="page-width site-wrapper wrapper main-content container">
      <div className="gc__layout_wrapper" style={{minHeight: "100vh"}}>
        <div>

          <div className="gc__form_header gc__section">
            <ul className="gc__breadcrumbs">
              <li><a className="gc__breadcrumb_button gc__breadcrumb_active">&nbsp;</a></li>
              <li><a className="gc__breadcrumb_disabled gc__breadcrumb_button">&nbsp;</a></li>
              <li><a className="gc__breadcrumb_disabled gc__breadcrumb_button">&nbsp;</a></li>
            </ul>
          </div>
          <div className="gc__giftcard_page">
          &nbsp;
          </div>
        </div>

        <div className="gc__giftcard_preview gc__hidden_mobile">
        &nbsp;
        <LoadingSpinner/>
        </div>

      </div>
    </div>
    </div>
  )
}
